import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import InfoModal from "../uploader/infoModal";
import { Form } from "antd";

import "./style.css";
import { useIntl } from "react-intl";

const Chart = props => {
  const {
    anchorId,
    arrayDiv,
    className,
    childrenList,
    footer,
    fromObligations,
    fromStatistics,
    idDivForChart,
    kpiType,
    metamodel,
    modal,
    renderInfo,
    renderOption,
    title,
    titleClassName,
    setModal
  } = props;

  const FormItem = Form.Item;
  const intl = useIntl();

  return (
    <div id={anchorId} className={className}>
      {!metamodel && (
        <InfoModal
          content={modal.content}
          isVisible={modal.visible}
          colorScheme={"default"}
          title={intl.formatMessage({id: "analytics.businessPerformance.modalTitle"})}
          type="primary"
          onClose={() =>
            setModal({
              content: null,
              visible: false
            })
          }
        />
      )}
      <div style={{ flex: "1 0 auto" }}>
        <div style={{ display: "flex", flex: "10" }}>
          {!metamodel ? (
            fromObligations ? null : (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between"
                }}
              >

                <div className={titleClassName}>
                  {title} &nbsp;
                  {<FontAwesomeIcon
                    icon={["far", "info-circle"]}
                    style={{
                      color: "#0090d1",
                      cursor: "pointer",
                      fontSize: "15px"
                    }}
                    onClick={() => renderInfo(idDivForChart)}
                  />}
                </div>
              </div>
            )
          ) : null}
          {!fromStatistics && !metamodel && !fromObligations ? (
            <div className="" style={{ flex: "1 1 auto" }}>
              <FormItem
                label=""
                style={{
                  width: "100%",
                  padding: "10px",
                  display: "inline-block"
                }}
              >
                {renderOption()}
              </FormItem>
            </div>
          ) : null}
        </div>
        {/*  punto in cui viene disegnato il div del grafico idDivForChart */}
        <div>
          <div
            style={{
              height:
                parseInt(kpiType) === 1 // 1 widget numerico
                  ? "100px"
                  : parseInt(kpiType) === 10 // 10 (numero casuale dato per il graph delle scadenze )
                    ? "500px"
                    : parseInt(kpiType) === 9 // 9 (numero casuale dato per le dashboard )
                      ? "340px"
                      : parseInt(kpiType) === 2 && title === "Indici della crisi"
                        ? "852px"
                        : "400px"
            }}
            id={idDivForChart}
          />
        </div>
        {/*  queste sotto sono le info centrali su adempimenti  */}
        {fromObligations && <div className="textInfo" id="obl-id"></div>}{" "}
        {/*  in caso di figli, vengono disegnati qui sotto  */}
        {childrenList ? arrayDiv : null}
      </div>

      {footer ? <div className="footerBoxCard">{footer}</div> : null}
    </div>
  );
};

export default Chart;
